import { ReactChild, ReactFragment, ReactPortal, useState } from 'react';

import axios from 'axios';

import Layout from '@/modules/core/components/Layout';

const CheryFormPage = () => {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    ville: '',
    codePostal: '',
    modeleVoiture: '',
  });
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleModeleSelection = (modele: string) => {
    setFormData({ ...formData, modeleVoiture: modele });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    // Validate required fields
    if (!formData.modeleVoiture) {
      setErrorMessage('Veuillez sélectionner un modèle de voiture.');
      return;
    }
    if (!formData.nom.trim()) {
      setErrorMessage('Veuillez entrer votre nom.');
      return;
    }
    if (!formData.prenom.trim()) {
      setErrorMessage('Veuillez entrer votre prénom.');
      return;
    }
    if (!formData.email.trim()) {
      setErrorMessage('Veuillez entrer votre email.');
      return;
    }
    if (!formData.telephone.trim()) {
      setErrorMessage('Veuillez entrer votre numéro de téléphone.');
      return;
    }
    if (!formData.ville.trim()) {
      setErrorMessage('Veuillez entrer votre ville.');
      return;
    }

    setSubmitting(true);

    try {
      const columns = [
        formData.nom,
        formData.prenom,
        formData.email,
        formData.telephone,
        formData.ville,
        formData.codePostal,
        formData.modeleVoiture,
      ];

      await axios.post('/api/cheryHandler', {
        columns,
      });

      setSuccessMessage('Votre formulaire a été soumis avec succès!');
      setFormData({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        ville: '',
        codePostal: '',
        modeleVoiture: '',
      });

      const statusElement = document.getElementById('status-message');
      if (statusElement) {
        statusElement.textContent =
          'Formulaire soumis avec succès. Merci pour votre intérêt.';
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi vers Google Sheet:", error);
      setErrorMessage(
        "Une erreur s'est produite lors de l'envoi du formulaire. Veuillez réessayer."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="relative w-full lg:mt-0 mt-10 mb-20 lg:mb-40 pt-10 lg:pt-20 pb-20 lg:pb-40 px-4 rounded-xl shadow-sm border border-gray-400 bg-no-repeat bg-cover bg-center"
      // style={{
      //   backgroundImage:
      //     'linear-gradient(rgba(255, 255, 255, 0.90), rgba(255, 255, 255)), url(/media/chery-bg.webp)',
      // }}
    >
      <div className="max-w-3xl mx-auto text-center">
        <img
          className=" mx-auto    rounded-3xl"
          src="/media/all.png"
          alt="Logo Chery"
          width={1080}
          height={10}
        />

        <h1 className="lg:text-3xl text-xl font-bold my-8 text-red-800">
          Choisissez votre modèle et demandez un devis !
        </h1>
      </div>

      <div
        id="status-message"
        className="sr-only"
        role="status"
        aria-live="polite"
      ></div>

      <div className="max-w-2xl mx-auto">
        {errorMessage && (
          <div
            role="alert"
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6"
          >
            {errorMessage}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className="relative bottom-6 bg-white shadow-lg rounded-xl p-8 space-y-6"
          aria-labelledby="form-heading"
        >
          <div className="flex flex-col items-start">
            <label className="text-gray-700 mb-4 font-medium">
              Quel modèle vous intéresse ?{' '}
              <span className="text-red-500" aria-hidden="true">
                *
              </span>
            </label>

            <div className="flex flex-wrap justify-evenly items-center gap-4 w-full">
              {/* <div className="flex flex-col items-center min-w-[280px]">
                <button
                  type="button"
                  onClick={() => handleModeleSelection('Tiggo 3x')}
                  className={`w-full h-20 p-2 border-2 ${
                    formData.modeleVoiture === 'Tiggo 3x'
                      ? 'border-red-500 bg-neutral-600'
                      : 'border-gray-300'
                  } rounded-2xl flex items-center justify-center bg-neutral-600 hover:bg-neutral-400`}
                  aria-pressed={formData.modeleVoiture === 'Tiggo 3x'}
                >
                  <div className="h-16 flex flex-col items-center justify-center">
                    <img
                      src="/media/TIGGO_3x.png"
                      alt="Chery Tiggo 3x"
                      className="h-6 object-contain w-28 lg:w-44"
                    />
                  </div>
                </button>
                <div className="flex items-center mt-2">
                  <input
                    type="radio"
                    id="tiggo3x"
                    name="modeleVoiture"
                    value="Tiggo 3x"
                    checked={formData.modeleVoiture === 'Tiggo 3x'}
                    onChange={() => handleModeleSelection('Tiggo 3x')}
                    className="mr-2"
                  />
                  <label
                    className="truncate text-sm lg:text-base"
                    htmlFor="tiggo3x"
                  >
                    Tiggo 3X CVT
                  </label>
                </div>
              </div> */}

              {/* <div className="flex flex-col items-center min-w-[280px]">
                <button
                  type="button"
                  onClick={() => handleModeleSelection('Tiggo 4 Pro')}
                  className={`w-full h-20 p-2 border-2 ${
                    formData.modeleVoiture === 'Tiggo 4 Pro'
                      ? 'border-red-500 bg-neutral-600'
                      : 'border-gray-300'
                  } rounded-2xl flex items-center justify-center bg-neutral-600 hover:bg-neutral-400`}
                  aria-pressed={formData.modeleVoiture === 'Tiggo 4 Pro'}
                >
                  <div className="h-16 flex flex-col items-center justify-center">
                    <img
                      src="/media/TIGGO_4.png"
                      alt="Chery Tiggo 4 Pro"
                      className="h-6 object-contain w-28 lg:w-44"
                    />
                  </div>
                </button>
                <div className="flex items-center mt-2">
                  <input
                    type="radio"
                    id="tiggo4pro"
                    name="modeleVoiture"
                    value="Tiggo 4 Pro"
                    checked={formData.modeleVoiture === 'Tiggo 4 Pro'}
                    onChange={() => handleModeleSelection('Tiggo 4 Pro')}
                    className="mr-2"
                  />
                  <label
                    className="truncate text-sm lg:text-base"
                    htmlFor="tiggo4pro"
                  >
                    Tiggo 4 PRO
                  </label>
                </div>
              </div> */}

              <div className="flex flex-col items-center min-w-[280px]">
                <button
                  type="button"
                  onClick={() => handleModeleSelection('Tiggo 7 Pro')}
                  className={`w-full h-20 p-2 border-2 ${
                    formData.modeleVoiture === 'Tiggo 7 Pro'
                      ? 'border-red-500 bg-neutral-600'
                      : 'border-gray-300'
                  } rounded-2xl flex items-center justify-center bg-neutral-600 hover:bg-neutral-400`}
                  aria-pressed={formData.modeleVoiture === 'Tiggo 7 Pro'}
                >
                  <div className="h-16 flex flex-col items-center justify-center">
                    <img
                      src="/media/TIGGO_7.png"
                      alt="Chery Tiggo 7 Pro"
                      className="h-6 object-contain w-28 lg:w-44"
                    />
                  </div>
                </button>
                <div className="flex items-center mt-2">
                  <input
                    type="radio"
                    id="tiggo7pro"
                    name="modeleVoiture"
                    value="Tiggo 7 Pro"
                    checked={formData.modeleVoiture === 'Tiggo 7 Pro'}
                    onChange={() => handleModeleSelection('Tiggo 7 Pro')}
                    className="mr-2"
                    required
                  />
                  <label
                    className="truncate text-sm lg:text-base"
                    htmlFor="tiggo7pro"
                  >
                    Tiggo 7 PRO
                  </label>
                </div>
              </div>
              <div className="flex flex-col items-center min-w-[280px]">
                <button
                  type="button"
                  onClick={() => handleModeleSelection('Arrizo 5 BVA')}
                  className={`w-full h-20 p-2 border-2 ${
                    formData.modeleVoiture === 'Arrizo 5 BVA'
                      ? 'border-red-500 bg-neutral-600'
                      : 'border-gray-300'
                  } rounded-2xl flex items-center justify-center bg-neutral-600 hover:bg-neutral-400`}
                  aria-pressed={formData.modeleVoiture === 'Arrizo 5 BVA'}
                >
                  <div className="h-16 flex flex-col items-center justify-center">
                    <img
                      src="/media/ARRIZO_5.png"
                      alt="Chery Arrizo 5 BVA"
                      className="h-6 object-contain w-28 lg:w-44"
                    />
                  </div>
                </button>
                <div className="flex items-center mt-2">
                  <input
                    type="radio"
                    id="arrizo5bva"
                    name="modeleVoiture"
                    value="Arrizo 5 BVA"
                    checked={formData.modeleVoiture === 'Arrizo 5 BVA'}
                    onChange={() => handleModeleSelection('Arrizo 5 BVA')}
                    className="mr-2"
                    required
                  />
                  <label
                    className="truncate text-sm lg:text-base"
                    htmlFor="arrizo5bva"
                  >
                    Arrizo 5 BVA
                  </label>
                </div>
              </div>

              <div className="flex flex-col items-center min-w-[280px]">
                <button
                  type="button"
                  onClick={() => handleModeleSelection('Tiggo 3X')}
                  className={`w-full h-20 p-2 border-2 ${
                    formData.modeleVoiture === 'Tiggo 3X'
                      ? 'border-red-500 bg-neutral-600'
                      : 'border-gray-300'
                  } rounded-2xl flex items-center justify-center bg-neutral-600 hover:bg-neutral-400`}
                  aria-pressed={formData.modeleVoiture === 'Tiggo 3X'}
                >
                  <div className="h-16 flex flex-col items-center justify-center">
                    <img
                      src="/media/TIGGO_3x.png"
                      alt="Chery Tiggo 3X"
                      className="h-6 object-contain w-28 lg:w-44"
                    />
                  </div>
                </button>
                <div className="flex items-center mt-2">
                  <input
                    type="radio"
                    id="tiggo3x"
                    name="modeleVoiture"
                    value="Tiggo 3X"
                    checked={formData.modeleVoiture === 'Tiggo 3X'}
                    onChange={() => handleModeleSelection('Tiggo 3X')}
                    className="mr-2"
                    required
                  />
                  <label
                    className="truncate text-sm lg:text-base"
                    htmlFor="tiggo3x"
                  >
                    Tiggo 3X
                  </label>
                </div>
              </div>

              <div className="flex flex-col items-center min-w-[280px]">
                <button
                  type="button"
                  onClick={() => handleModeleSelection('Tiggo 4X')}
                  className={`w-full h-20 p-2 border-2 ${
                    formData.modeleVoiture === 'Tiggo 4X'
                      ? 'border-red-500 bg-neutral-600'
                      : 'border-gray-300'
                  } rounded-2xl flex items-center justify-center bg-neutral-600 hover:bg-neutral-400`}
                  aria-pressed={formData.modeleVoiture === 'Tiggo 4X'}
                >
                  <div className="h-16 flex flex-col items-center justify-center">
                    <img
                      src="/media/TIGGO_4.png"
                      alt="Chery Tiggo 4X"
                      className="h-6 object-contain w-28 lg:w-44"
                    />
                  </div>
                </button>
                <div className="flex items-center mt-2">
                  <input
                    type="radio"
                    id="tiggo4x"
                    name="modeleVoiture"
                    value="Tiggo 4X"
                    checked={formData.modeleVoiture === 'Tiggo 4X'}
                    onChange={() => handleModeleSelection('Tiggo 4X')}
                    className="mr-2"
                    required
                  />
                  <label
                    className="truncate text-sm lg:text-base"
                    htmlFor="tiggo4x"
                  >
                    Tiggo 4X
                  </label>
                </div>
              </div>

              <div className="flex flex-col items-center min-w-[280px]">
                <button
                  type="button"
                  onClick={() => handleModeleSelection('Arrizo 8')}
                  className={`w-full h-20 p-2 border-2 ${
                    formData.modeleVoiture === 'Arrizo 8'
                      ? 'border-red-500 bg-neutral-600'
                      : 'border-gray-300'
                  } rounded-2xl flex items-center justify-center bg-neutral-600 hover:bg-neutral-400`}
                  aria-pressed={formData.modeleVoiture === 'Arrizo 8'}
                >
                  <div className="h-16 flex flex-col items-center justify-center">
                    <img
                      src="/media/arrizo8.png"
                      alt="Chery Arrizo 8"
                      className="h-6 object-contain w-28 lg:w-44"
                    />
                  </div>
                </button>
                <div className="flex items-center mt-2">
                  <input
                    type="radio"
                    id="arrizo8"
                    name="modeleVoiture"
                    value="Arrizo 8"
                    checked={formData.modeleVoiture === 'Arrizo 8'}
                    onChange={() => handleModeleSelection('Arrizo 8')}
                    className="mr-2"
                    required
                  />
                  <label
                    className="truncate text-sm lg:text-base"
                    htmlFor="arrizo8"
                  >
                    Arrizo 8
                  </label>
                </div>
              </div>
              {/* <div className="flex flex-col items-center min-w-[280px]">
                <button
                  type="button"
                  onClick={() => handleModeleSelection('Arrizo 5')}
                  className={`w-full h-20 p-2 border-2 ${
                    formData.modeleVoiture === 'Arrizo 5'
                      ? 'border-red-500 bg-neutral-600'
                      : 'border-gray-300'
                  } rounded-2xl flex items-center justify-center bg-neutral-600 hover:bg-neutral-400`}
                  aria-pressed={formData.modeleVoiture === 'Arrizo 5'}
                >
                  <div className="h-16 flex flex-col items-center justify-center">
                    <img
                      src="/media/ARRIZO_5.png"
                      alt="Chery Arrizo 5"
                      className="h-6 object-contain w-28 lg:w-44"
                    />
                  </div>
                </button>
                <div className="flex items-center mt-2">
                  <input
                    type="radio"
                    id="arrizo5"
                    name="modeleVoiture"
                    value="Arrizo 5"
                    checked={formData.modeleVoiture === 'Arrizo 5'}
                    onChange={() => handleModeleSelection('Arrizo 5')}
                    className="mr-2"
                  />
                  <label
                    className="truncate text-sm lg:text-base"
                    htmlFor="arrizo5"
                  >
                    Arrizo 5 CVT
                  </label>
                </div>
              </div> */}
            </div>
          </div>
          <div className="flex flex-col items-start">
            <label htmlFor="nom" className="text-gray-700 mb-2 font-medium">
              Nom de famille{' '}
              <span className="text-red-500" aria-hidden="true">
                *
              </span>
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
              value={formData.nom}
              onChange={handleChange}
              required
              aria-required="true"
            />
          </div>

          <div className="flex flex-col items-start">
            <label htmlFor="prenom" className="text-gray-700 mb-2 font-medium">
              Prénom{' '}
              <span className="text-red-500" aria-hidden="true">
                *
              </span>
            </label>
            <input
              type="text"
              id="prenom"
              name="prenom"
              className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
              value={formData.prenom}
              onChange={handleChange}
              required
              aria-required="true"
            />
          </div>

          <div className="flex flex-col items-start">
            <label htmlFor="email" className="text-gray-700 mb-2 font-medium">
              Email{' '}
              <span className="text-red-500" aria-hidden="true">
                *
              </span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
              value={formData.email}
              onChange={handleChange}
              required
              aria-required="true"
            />
          </div>

          <div className="flex flex-col items-start">
            <label
              htmlFor="telephone"
              className="text-gray-700 mb-2 font-medium"
            >
              Téléphone{' '}
              <span className="text-red-500" aria-hidden="true">
                *
              </span>
            </label>
            <input
              type="tel"
              id="telephone"
              name="telephone"
              className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
              value={formData.telephone}
              onChange={handleChange}
              required
              aria-required="true"
            />
          </div>

          <div className="flex flex-col items-start">
            <label htmlFor="ville" className="text-gray-700 mb-2 font-medium">
              Ville{' '}
              <span className="text-red-500" aria-hidden="true">
                *
              </span>
            </label>
            <input
              type="text"
              id="ville"
              name="ville"
              className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
              value={formData.ville}
              onChange={handleChange}
              required
              aria-required="true"
            />
          </div>

          {/* <div className="flex flex-col items-start">
            <label
              htmlFor="codePostal"
              className="text-gray-700 mb-2 font-medium"
            >
              Code postal
            </label>
            <input
              type="text"
              id="codePostal"
              name="codePostal"
              placeholder="Par exemple : 2000"
              className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
              value={formData.codePostal}
              onChange={handleChange}
            />
          </div> */}

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-red-600 to-red-800 text-white font-semibold py-3 rounded-xl hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition duration-200"
            disabled={submitting}
            aria-busy={submitting}
          >
            {submitting ? 'Envoi en cours...' : 'Envoyer ma demande'}
          </button>

          {/* Notifications below the submit button */}
          {errorMessage && (
            <div
              role="alert"
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mt-4 text-center"
            >
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div
              role="alert"
              className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mt-4 text-center"
            >
              {successMessage}
            </div>
          )}

          <p className="text-xs text-gray-500 mt-2">
            <span className="text-red-500" aria-hidden="true">
              *
            </span>{' '}
            Indique un champ obligatoire
          </p>
        </form>
      </div>
    </div>
  );
};

export default CheryFormPage;

CheryFormPage.getLayout = function getLayout(
  page: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined
) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};
